import store from '@/store/index';
import axios, { AxiosResponse } from 'axios';

const Recurring = {
     getRecurringPayment: async policyNumber => {
          return await axios({
               method: 'GET',
               url: process.env.VUE_APP_API_URI2 + '/recurring?policy_num=' + policyNumber,
          });
     },
     addCancelRecurringPayment: async data => {
          return await axios({
               method: 'POST',
               url: process.env.VUE_APP_API_URI2 + '/recurring',
               data,
          });
     },
};

export default Recurring;
